import type { EarnedAwardFieldsFragment } from '~/graphql/generated/graphql';

import { AwardType } from '~/graphql/generated/graphql';

type EarnedAward = EarnedAwardFieldsFragment;
type BadgeAward = EarnedAward & { award: Extract<NonNullable<EarnedAward['award']>, { __typename?: 'Badge' }> };
type SkillAward = EarnedAward & { award: Extract<NonNullable<EarnedAward['award']>, { __typename?: 'Skill' }> };

export const isBadgeAward = (earnedAward: EarnedAward): earnedAward is BadgeAward =>
  earnedAward.awardType === AwardType.Badge;

export const isSkillAward = (earnedAward: EarnedAward): earnedAward is SkillAward =>
  earnedAward.awardType === AwardType.Skill;
